<template>
  <div chuncheon-popup v-if="chuncheonPopupStatus && item">
    <article :style="`background-image: url('${img}')`" :class="type">
      <a class="btn-close" @click="close"/>
      <h3 v-html="item.title" v-if="type === 'type-01' || type === 'type-02'"/>
      <div class="body" v-if="type === 'type-01'">
        <div class="cover" v-for="(item,i) in item.explain" :key="i">
          <h4 v-if="item.title" v-html="item.title"/>
          <p v-if="item.body" v-html="item.body"/>
          <p v-if="item.name" class="name" v-html="item.name"/>
        </div>
      </div>
      <div class="body ss" v-else-if="type === 'type-02'">
        <div class="cover">
          <p v-if="item.body" v-html="item.body"/>
          <p v-if="item.name" class="name" v-html="item.name"/>
        </div>
      </div>
      <div class="paging" v-if="type !== 'type-03'">
        <a class="l" @click="prev"/>
        <p>{{+this.idx+1}} / {{list.length}}</p>
        <a class="r" @click="next"/>
      </div>
    </article>
    <p class="dim" @click="close"/>
  </div>
</template>

<script>
export default {
  name: "ChuncheonPopup",
  computed: {
    chuncheonPopupStatus() {
      return this.$store.state.chuncheonPopup;
    },
    item() {
      return this.list[this.idx];
    },
    img() {
      return this.item ? (this.item.imgM || this.item.bg || this.item.img) : '';
    },
    list() {
      return this.chuncheonPopupStatus.info.list;
    },
  },
  watch: {
    chuncheonPopupStatus(val) {
      if (val) {
        this.idx = val.idx;
        this.type = val.type;
      }
    },
  },
  data() {
    return {
      idx: 0,
      type: null,
    };
  },
  methods: {
    prev() {
      this.idx = this.idx === 0 ? this.list.length-1 : this.idx - 1;
    },
    next() {
      this.idx = this.idx === this.list.length-1 ? 0 : this.idx + 1;
    },
    close() {
      this.status = false;
      this.$store.commit('setChuncheonPopup', null);
    },
  },
}
</script>

<style lang="less">
@import "~@/less/proj.less";

[chuncheon-popup]{ .fix; .wh(100%); z-index: 100; .lt(0,0);
  .dim{.abs; .bgc(rgba(0,0,0,.5)); .wh(100%);}
  article{ .abs; .wh(375,552); .lt(50%,50%); transform: translate(-50%,-50%); z-index:1; .cover; .bg-c; .no-repeat; transition: margin-top 0.3s;
    h3{.fs(24,32,-2); color:white; .p(20);
      .en & { .fs(28,36,0); .medium;  .w(270); .keep-all; }
    }
    .body{ .abs; .t(53%); transform: translateY(-50%);
      .cover{ .p(0,20);
        &:nth-of-type(2){.mt(24);}
        h4 {.fs(18,18,-0.82); color:white; .mb(6);
          .en & { .fs(18,24,0); .semi-bold; }
        }
        p {color:#e0e0e0; .fs(14,24,-.5);
          .en & { .fs(16,19,0); .regular; }
          &.name{ .mt(10);}
        }
      }
    }
    .paging{.abs; .b(0); .wh(100%,155);
      p{.abs; .b(20); .l(50%); transform: translateX(-50%); color:white; .fs(16,24,-.5);}
      a{.block; .abs; .wh(80,100%); .bg-s(29,28); .bg-y(107); .no-repeat; .t(0);
        &.l{.l(0); .bg('@{img}/common/tri-left-white.svg'); .bg-x(20);}
        &.r{.r(0); .bg('@{img}/common/tri-right-white.svg'); .bg-x(32);}
      }
    }
    .btn-close{ .contain('@{img}/common/close-white.svg'); .wh(32); .abs; .rt(20,20); z-index:1;}
    &.type-01 {
    }
    &.type-02 {
      .body {
        .cover {
          p {
            .en & { .fs(18,26,0);
              &.name{ .mt(20);}
            }
          }
        }
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    article { .wh(513,536);
      &.scroll-up { .mt(0); }

      h3 {
        .en & { .w; }
      }
      .body{
        .cover{ .p(0,20);
          h4 {
            .en & { .fs(22,26,0); }
          }
          p {.fs(16,24,-.5);
            .en & { .fs(18,24,0); }
            &.name{ .mt(20);}
          }
        }
      }
    }
  }

  @media (min-width: @screen-xxl-min) {
    article { .wh(800,836);
      &.scroll-up { .mt(0); }

      h3{.fs(32,48,-1.5); .p(30);
        .en & { .fs(28,46,0); }
      }
      .btn-close{ .rt(30,30);}
      .body{ .w(500); .l(50%); .ml(-250);
        .cover{ .p(0);
          h4 { .fs(24,24,-1);
            .en & { .fs(22,26,0); }
          }
          p {.fs(18,28,-.5); .mt(15);
            .en & { .fs(20,24,0); .mt(10); }
            &.name{ .mt(20);}
          }
          &:nth-child(2) { .mt(50);

          }
        }
      }
      .paging{
        p { transform: none; .fs(20,50,-0.6);}
        a { .block; .abs; .wh(80,100%); .bg-s(50,50); .bg-y(75); .no-repeat; .t(0);
          &.l{.l(0); .bg('@{img}/common/bottom-btn-left.svg'); .bg-x(30);}
          &.r{.r(0); .bg('@{img}/common/bottom-btn-right.svg'); .bg-x(0);}
        }
      }

    }
  }
}

</style>
